import ResponseBodyVirtual_vue_vue_type_script_setup_true_lang_default from "./ResponseBodyVirtual.vue_vue_type_script_setup_true_lang.js";
/* empty css                                                        */
//#region src/v2/blocks/response-block/components/ResponseBodyVirtual.vue
var ResponseBodyVirtual_default = ResponseBodyVirtual_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ResponseBodyVirtual_default as default };

//# sourceMappingURL=ResponseBodyVirtual.vue.js.map